import PlatformSite from './PlatformSite';

export default PlatformSite;
